// frontend/src/features/ups/utils/formatOwnerLabel.js
// Shared UPS ownership display rule for mixed-workforce rows.
// COMPANY => Internal
// AGENCY + agency_name => Agency — {agency_name}
// AGENCY without name => Agency
// unknown => —

export function formatOwnerLabel(row) {
  if (row?.workforce_source === 'COMPANY') return 'Internal';

  if (row?.workforce_source === 'AGENCY') {
    if (row?.agency_name) return `Agency — ${row.agency_name}`;
    return 'Agency';
  }

  return '—';
}